import { UrlTree } from '@angular/router';

import { BaseModel, RecursivePartial, SM } from '@models/base';

export enum MainMenuItemType {
    Unknown          = 0,
    Link             = 1,
    Folder           = 2,
    Separator        = 3,
    FlexSpace        = 4,
    TaskFilter       = 5,
}

export enum MainMenuItemVisibility {
    Mobile           = 1,
    DesktopExpanded  = 2,
    DesktopCollapsed = 4,
    Desktop          = 6,
    Any              = 65535,
}

export enum MainMenuFolderType {
    Custom          = 0,
    Tasks           = 1,
    Kanbans         = 2,
    GroupChats      = 3,
    DirectChats     = 4,
}

export class MainMenuItem extends BaseModel {
    type: MainMenuItemType = MainMenuItemType.Unknown;
    id?: string;
    editable?: boolean;
    unique?: boolean;
    visibility?: number = MainMenuItemVisibility.Any;
    counters?: string[];   // counterType, prefix e.g. ['tasks', 'inbox']

    // link
    title?: string = '';
    icon?: string;
    iconText?: string;
    color?: string;
    route?: string[];
    routeFull?: any[];
    routeExternal?: string;
    queryParams?: SM<string>;
    queryParamsHandling?: 'merge' | 'preserve' | 'replace' | '';
    matchRouterExact?: boolean | [boolean, boolean];        // [desktop, mobile]

    // task filter
    filterId?: string;

    // folder
    subtype?: MainMenuFolderType;
    maxCount?: number;
    children?: MainMenuItem[];

    _vis: SM<number> = {};

    constructor(json?: RecursivePartial<MainMenuItem>) {
        super(json);
        this.parseMainMenuItem(json || {});
    }

    parse(json: RecursivePartial<MainMenuItem>): MainMenuItem {
        super.parse(json);
        this.parseMainMenuItem(json);
        return this;
    }

    private parseMainMenuItem(json: RecursivePartial<MainMenuItem>): void {
        MainMenuItem.assignFields<MainMenuItem, UrlTree | Function>(this, json, [
            'id',
            'type',
            'unique',
            'editable',
            'visibility',
            'counters',

            'title',
            'icon',
            'iconText',
            'color',
            'route',
            'routeFull',
            'routeExternal',
            'queryParams',
            'queryParamsHandling',
            'matchRouterExact',

            'filterId',

            'subtype',
            'maxCount',
        ]);
        MainMenuItem.assignClassArrays<Omit<MainMenuItem, 'routeFull'>>(this, json, { children: MainMenuItem });
        const v = this.visibility || 0;
        this._vis = {
            m: v & MainMenuItemVisibility.Mobile,
            e: v & MainMenuItemVisibility.DesktopExpanded,
            c: v & MainMenuItemVisibility.DesktopCollapsed,
            d: v & MainMenuItemVisibility.Desktop
        }
    }
}
